/** @format */

import React, { useEffect } from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Container from 'react-bootstrap/Container';
import getUrlParams from 'utils/getUrlParams';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBrokerObject } from 'stateContainer/actions';
import { Spinner } from 'react-bootstrap';
import ObjectListingContents from 'views/Broker/Profile/ObjectListing/ObjectListingContents';

export default function ObjectListing(props) {
  const { objectId } = getUrlParams(['objectId']);
  const {
    brokerObject: {
      data: { object, broker },
      isFetching
    }
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBrokerObject(objectId));
  }, [objectId]);

  const ObjectListContents = () => {
    return (
      <ObjectListingContents
        {...props}
        objectId={objectId}
        brokerProfileUrl={`${props.t(
          'lang_route:common_broker_profile'
        )}?profileId=${object.brokerId}`}
        priceText={object.price}
        address={object.location}
        imageList={object.imageList}
        title={object.title}
        description={object.description}
        noOfBathrooms={object.noOfBathrooms}
        noOfBedrooms={object.noOfBedrooms}
        isSwimmingPool={object.swimmingPool}
        coordinates={object.coordinate}
        dimensions={object.dimensions}
        brokerDetails={broker}
      />
    );
  };

  const Loader = () => {
    return (
      <Container fluid className='broker-profile-loading-container'>
        <Spinner
          animation='border'
          role='status'
          style={{ color: 'var(--color-primary-pink)' }}
        />
      </Container>
    );
  };

  const objectDataExists =
    object && object !== undefined && Object.keys(object).length > 0;

  return (
    <>
      <div className='main-container imagelist-view'>
        <Header flow={props.flow} {...props} />
        {isFetching ? (
          <Loader />
        ) : (
          <Container fluid className='content-wrapper'>
            {objectDataExists && <ObjectListContents />}
          </Container>
        )}
        <Footer {...props} />
      </div>

      <div className='main-container imagelist-view-mobile'>
        <Header flow={props.flow} {...props} />
        {isFetching ? (
          <Loader />
        ) : (
          <Container fluid className='content-wrapper'>
            {objectDataExists && (
              <Container fluid className='content-wrapper'>
                <ObjectListContents />
              </Container>
            )}
          </Container>
        )}

        <Footer {...props} />
      </div>
    </>
  );
}
